<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <div class="mb-3">
      <table class="tablaBusqueda" v-if="opcionConsulta == 1">
        <tr>
          <td>
            <label for="cedulaBusqueda" class="form-label">Cédula</label>
            <input
              type="text"
              class="form-control"
              id="cedulaBusqueda"
              name="cedulaBusqueda"
              v-model="cedulaBusqueda"
              @input="clearFields('cedula')"
              style="width: 150px; text-transform: uppercase"
              required
            />
          </td>
          <td>
            <label for="nombreBusqueda" class="form-label">Nombre</label>
            <input
              type="text"
              class="form-control"
              id="nombreBusqueda"
              name="nombreBusqueda"
              v-model="nombreBusqueda"
              @input="clearFields('nombre')"
              style="width: 500px; text-transform: uppercase"
              required
            />
          </td>
          <td style="vertical-align: bottom">
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="buscar()"
              title="Buscar"
            >
              <i
                class="material-icons"
                style="font-size: 24px; color: blue; cursor: pointer"
                >search</i
              >
            </button>
          </td>
          <td style="vertical-align: bottom">
            <button
              type="submit"
              class="btn btn-outline-primary"
              @click.prevent="getDataPaginaTodos(1)"
              title="Todos los registros"
            >
              <i
                class="material-icons"
                style="font-size: 24px; color: blue; cursor: pointer"
                >auto_awesome_motion</i
              >Todos los registros
            </button>
          </td>
          <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
          <td style="vertical-align: bottom">
            <button
              type="submit"
              class="btn btn-outline-success"
              data-bs-toggle="modal"
              data-bs-target="#ventanaModalPaso1"
              @click="abrirModalCrear"
              title="Nuevo registro"
            >
              <i
                class="material-icons"
                style="font-size: 24px; color: green; cursor: pointer"
                >add_box</i
              >Nuevo registro
            </button>
          </td>
        </tr>
      </table>
    </div>
    <table class="table table-hover" id="sampleTable">
      <thead>
        <tr>
          <th scope="col">Documento</th>
          <th scope="col">Nombre</th>
          <th scope="col">Teléfono</th>
          <th scope="col">E-mail</th>
          <th scope="col" v-if="opcionMenu == 1">Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="persona in datosPaginados"
          :key="persona.idPersona"
          @click="handleRowClick($event, persona.idPersona)"
        >
          <td>{{ persona.documento }}</td>
          <td>{{ persona.nombreCompleto }}</td>
          <td>{{ persona.telefono }}</td>
          <td>{{ persona.email }}</td>
          <td v-if="opcionMenu == 1">
            <select
              class="form-select form-select-sm"
              @change="
                handleAction($event, persona.idPersona, persona.nombreCompleto)
              "
            >
              <option disabled selected>Seleccione...</option>
              <option value="editar">Editar</option>
              <option value="detalles">Detalles</option>
              <option value="borrar">Borrar</option>
              <option value="separador" disabled></option>
              <option value="crearCita">Nueva Cita</option>
              <option value="crearNotificacion">Nueva Notificación</option>
            </select>
          </td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example" v-if="!popupAyuda">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()">
          <a class="page-link" href="#">Anterior</a>
        </li>
        <li
          id="lugar"
          v-for="pagina in totalPaginas()"
          v-bind:key="pagina"
          v-on:click="getDataPagina(pagina)"
          class="page-item"
          v-bind:class="isActive(pagina)"
        >
          <a class="page-link" href="#">{{ pagina }}</a>
        </li>
        <li class="page-item" v-on:click="getNextPage()">
          <a class="page-link" href="#">Siguiente</a>
        </li>
      </ul>
    </nav>

    <!-- Modal Paso 1: Crear Persona -->
    <div
      class="modal fade"
      id="ventanaModalPaso1"
      tabindex="-1"
      aria-labelledby="modalLabelPaso1"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title" id="modalLabelPaso1">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label for="idPersona" class="form-label">IdPersona</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="idPersona"
                      name="idPersona"
                      v-model="datoPersona.idPersona"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idTipoIden" class="form-label"> Tipo Id.</label>
                  </div>
                  <div class="col-2">
                    <select
                      class="form-control"
                      id="idTipoIden"
                      name="idTipoIden"
                      v-model="datoPersona.idTipoIden"
                    >
                      <option
                        v-for="tipoIden in tipoIdens"
                        :value="tipoIden.idTipoIden"
                        :key="tipoIden.idTipoIden"
                      >
                        {{ tipoIden.nombre }}
                      </option>
                    </select>
                  </div>
                  <div class="col-2">
                    <label for="documento" class="form-label">Documento</label>
                  </div>
                  <div class="col-2">
                    <input
                      type="text"
                      class="form-control"
                      id="documento"
                      name="documento"
                      v-model="datoPersona.documento"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                  <div class="col-2">
                    <label for="idEstadoCivil" class="form-label">
                      Estado Civil</label
                    >
                  </div>
                  <div class="col-2">
                    <select
                      class="form-control"
                      id="idEstadoCivil"
                      name="idEstadoCivil"
                      v-model="datoPersona.idEstadoCivil"
                    >
                      <option
                        v-for="estadoCivil in estadoCivils"
                        :value="estadoCivil.idEstadoCivil"
                        :key="estadoCivil.idEstadoCivil"
                      >
                        {{ estadoCivil.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="fechaNac" class="form-label">FechaNac</label>
                  </div>
                  <div class="col-2">
                    <input
                      type="date"
                      class="form-control"
                      id="fechaNac"
                      name="fechaNac"
                      v-model="datoPersona.fechaNac"
                      required
                    />
                  </div>
                  <div class="col-2">
                    <label for="sexo" class="form-label">Sexo</label>
                  </div>
                  <div class="col-2">
                    <select
                      class="form-control"
                      id="sexo"
                      name="sexo"
                      v-model="datoPersona.sexo"
                      required
                    >
                      <option value="">Seleccione el género</option>
                      <option value="M">Masculino</option>
                      <option value="F">Femenino</option>
                    </select>
                  </div>
                  <div class="col-2">
                    <label for="telefono" class="form-label">Teléfono</label>
                  </div>
                  <div class="col-2">
                    <input
                      type="text"
                      class="form-control"
                      id="telefono"
                      name="telefono"
                      v-model="datoPersona.telefono"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="primerNombre" class="form-label"
                      >Primer Nombre</label
                    >
                  </div>
                  <div class="col-4">
                    <input
                      type="text"
                      class="form-control"
                      id="primerNombre"
                      name="primerNombre"
                      v-model="datoPersona.primerNombre"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                  <div class="col-2">
                    <label for="segundoNombre" class="form-label"
                      >Segundo Nombre</label
                    >
                  </div>
                  <div class="col-4">
                    <input
                      type="text"
                      class="form-control"
                      id="segundoNombre"
                      name="segundoNombre"
                      v-model="datoPersona.segundoNombre"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="primerApellido" class="form-label"
                      >PrimerApellido</label
                    >
                  </div>
                  <div class="col-4">
                    <input
                      type="text"
                      class="form-control"
                      id="primerApellido"
                      name="primerApellido"
                      v-model="datoPersona.primerApellido"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                  <div class="col-2">
                    <label for="segundoApellido" class="form-label"
                      >SegundoApellido</label
                    >
                  </div>
                  <div class="col-4">
                    <input
                      type="text"
                      class="form-control"
                      id="segundoApellido"
                      name="segundoApellido"
                      v-model="datoPersona.segundoApellido"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idLocalidad" class="form-label">
                      Localidad</label
                    >
                  </div>
                  <div class="col-4">
                    <select
                      class="form-control"
                      id="idLocalidad"
                      name="idLocalidad"
                      v-model="datoPersona.idLocalidad"
                    >
                      <option
                        v-for="localidad in localidads"
                        :value="localidad.idLocalidad"
                        :key="localidad.idLocalidad"
                      >
                        {{ localidad.nombre }}
                      </option>
                    </select>
                  </div>
                  <div class="col-2">
                    <label for="email" class="form-label">Email</label>
                  </div>
                  <div class="col-4">
                    <input
                      type="text"
                      class="form-control"
                      id="email"
                      name="email"
                      v-model="datoPersona.email"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="direccion" class="form-label">Dirección</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="direccion"
                      name="direccion"
                      v-model="datoPersona.direccion"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <button @click.prevent="mostrarOcultarBloque">
                {{
                  mostrarBloque
                    ? "(-) Menos información"
                    : "(+) Más información"
                }}
              </button>
              <div v-if="mostrarBloque" class="mb-3">
                <div class="mb-3">
                  <div class="row">
                    <div class="col-2">
                      <label for="fechaReg" class="form-label"
                        >Fecha de registro</label
                      >
                    </div>
                    <div class="col-10">
                      <input
                        type="text"
                        class="form-control"
                        id="fechaReg"
                        name="fechaReg"
                        v-model="datoPersona.fechaReg"
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
              title="Cerrar"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="siguientePaso1"
              v-if="btnCrear"
              title="Siguiente"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >arrow_forward</i
              >Siguiente
            </button>
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="actualizarPersona"
              v-if="btnEditar"
              title="Actualizar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >update</i
              >Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Paso 2: Crear Usuario -->
    <div
      class="modal fade"
      id="ventanaModalPaso2"
      tabindex="-1"
      aria-labelledby="modalLabelPaso2"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title" id="modalLabelPaso2">
              <i class="fa fa-user"></i> Crear Usuario
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <!-- Botón Lista de Valores  Perfil -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idPerfil" class="form-label"> Perfil</label>
                  </div>
                  <div class="col-10">
                    <select
                      class="form-control"
                      id="idPerfil"
                      name="idPerfil"
                      v-model="datoUsuario.idPerfil"
                      @change="actualizarDatosDesdePerfil"
                    >
                      <option
                        v-for="perfil in perfils"
                        :value="perfil.idPerfil"
                        :key="perfil.idPerfil"
                      >
                        {{ perfil.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Botón Lista de Valores  Perfil -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="nombre" class="form-label">Nombre</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="nombre"
                      name="nombre"
                      v-model="datoUsuario.nombre"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="clave" class="form-label">Clave</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="clave"
                      name="clave"
                      v-model="datoUsuario.clave"
                      required
                    />
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <label class="form-label">Permisos del Usuario</label>
                <div class="row">
                  <!-- Línea 1 -->
                  <div class="col-md-4">
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="moduloAdministracion"
                        v-model="datoUsuario.moduloAdministracion"
                        :true-value="1"
                        :false-value="0"
                      />
                      <label class="form-check-label" for="moduloAdministracion"
                        >Modulo Administración</label
                      >
                    </div>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="moduloAtencion"
                        v-model="datoUsuario.moduloAtencion"
                        :true-value="1"
                        :false-value="0"
                      />
                      <label class="form-check-label" for="moduloAtencion"
                        >Modulo Atención</label
                      >
                    </div>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="moduloFacturacion"
                        v-model="datoUsuario.moduloFacturacion"
                        :true-value="1"
                        :false-value="0"
                      />
                      <label class="form-check-label" for="moduloFacturacion"
                        >Modulo Facturación</label
                      >
                    </div>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="moduloDashboards"
                        v-model="datoUsuario.moduloDashboards"
                        :true-value="1"
                        :false-value="0"
                      />
                      <label class="form-check-label" for="moduloDashboards"
                        >Modulo Dashboards</label
                      >
                    </div>
                  </div>

                  <!-- Línea 2 -->
                  <div class="col-md-4">
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="menuParametros"
                        v-model="datoUsuario.menuParametros"
                        :true-value="1"
                        :false-value="0"
                      />
                      <label class="form-check-label" for="menuParametros"
                        >Menú Parámetros</label
                      >
                    </div>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="menuProcesos"
                        v-model="datoUsuario.menuProcesos"
                        :true-value="1"
                        :false-value="0"
                      />
                      <label class="form-check-label" for="menuProcesos"
                        >Menú Procesos</label
                      >
                    </div>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="menuReportes"
                        v-model="datoUsuario.menuReportes"
                        :true-value="1"
                        :false-value="0"
                      />
                      <label class="form-check-label" for="menuReportes"
                        >Menú Reportes</label
                      >
                    </div>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="menuAyuda"
                        v-model="datoUsuario.menuAyuda"
                        :true-value="1"
                        :false-value="0"
                      />
                      <label class="form-check-label" for="menuAyuda"
                        >Menú Ayuda</label
                      >
                    </div>
                  </div>

                  <!-- Línea 3 -->
                  <div class="col-md-4">
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="opcionConsulta"
                        v-model="datoUsuario.opcionConsulta"
                        :true-value="1"
                        :false-value="0"
                      />
                      <label class="form-check-label" for="opcionConsulta"
                        >Opción Consulta</label
                      >
                    </div>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="opcionOperaciones"
                        v-model="datoUsuario.opcionOperaciones"
                        :true-value="1"
                        :false-value="0"
                      />
                      <label class="form-check-label" for="opcionOperaciones"
                        >Opción Operaciones</label
                      >
                    </div>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="opcionDescarga"
                        v-model="datoUsuario.opcionDescarga"
                        :true-value="1"
                        :false-value="0"
                      />
                      <label class="form-check-label" for="opcionDescarga"
                        >Opción Descarga</label
                      >
                    </div>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="opcionMenu"
                        v-model="datoUsuario.opcionMenu"
                        :true-value="1"
                        :false-value="0"
                      />
                      <label class="form-check-label" for="opcionMenu"
                        >Opción Menú</label
                      >
                    </div>
                  </div>

                  <!-- Línea 4 -->
                  <div class="col-md-4">
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="moduloAuditoria"
                        v-model="datoUsuario.moduloAuditoria"
                        :true-value="1"
                        :false-value="0"
                      />
                      <label class="form-check-label" for="moduloAuditoria"
                        >Modulo Auditoria</label
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              @click.prevent="anteriorPaso2"
              title="Anterior"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: gray; cursor: pointer"
                >arrow_back</i
              >Anterior
            </button>
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="siguientePaso2"
              title="Siguiente"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >arrow_forward</i
              >Siguiente
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Paso 3: Establecer Médico -->
    <div
      class="modal fade"
      id="ventanaModalPaso3"
      tabindex="-1"
      aria-labelledby="modalLabelPaso3"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title" id="modalLabelPaso3">
              <i class="fa fa-user-md"></i> Establecer como Médico
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <br />

          <div class="mb-3">
            <div class="row">
              <div class="col-4"></div>
              <div class="col-4">
                <div class="mb-3 form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="registrarComoMedico"
                    v-model="registrarComoMedico"
                  />
                  <label class="form-check-label" for="registrarComoMedico">
                    Registrar como Médico
                  </label>
                </div>
              </div>
              <div class="col-4"></div>
            </div>
          </div>
          <br />
          <form v-if="registrarComoMedico">
            <div class="modal-body">
              <!-- Botón Lista de Valores  Especialidad -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idEspecialidad" class="form-label">
                      Especialidad</label
                    >
                  </div>
                  <div class="col-10">
                    <select
                      class="form-control"
                      id="idEspecialidad"
                      name="idEspecialidad"
                      v-model="datoMedico.idEspecialidad"
                    >
                      <option
                        v-for="especialidad in especialidads"
                        :value="especialidad.idEspecialidad"
                        :key="especialidad.idEspecialidad"
                      >
                        {{ especialidad.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Botón Lista de Valores  Especialidad -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="documento" class="form-label">Documento</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="documento"
                      name="documento"
                      v-model="datoMedico.documento"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              @click.prevent="anteriorPaso3"
              title="Anterior"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: gray; cursor: pointer"
                >arrow_back</i
              >Anterior
            </button>
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="finalizarWizard"
              title="Finalizar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: green; cursor: pointer"
                >check</i
              >Finalizar
            </button>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import config from '@/config';
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import api from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import dateFormat from "@/modules/dateFormat.js";

import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;
import swal from "sweetalert";

export default {
  props: {
    p_idEmpresa: {
      type: Number,
      required: true,
    },
  },
  components: {
    Layout,
    Footer,
  },
  data() {
    return {
      opcionConsulta: 0,
      opcionOperaciones: 0,
      opcionDescarga: 0,
      opcionMenu: 0,
      personas: [],
      datoPersona: {},
      responsePersona: {},
      datoUsuario: {},
      datoMedico: {},
      cedulaBusqueda: "",
      nombreBusqueda: "",
      titulo: "",
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      tipoIdens: [],
      localidads: [],
      estadoCivils: [],
      perfils: [],
      especialidads: [],
      mostrarBloque: false,
      popupAyuda: false,
      showModalHelp: false,
      idSuscripcion: 0,
      registrarComoMedico: 0,
    };
  },
  mounted() {
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.opcionConsulta =
      parseInt(window.sessionStorage.getItem("opcionConsulta"), 10) || 0;
    this.opcionOperaciones =
      parseInt(window.sessionStorage.getItem("opcionOperaciones"), 10) || 0;
    this.opcionDescarga =
      parseInt(window.sessionStorage.getItem("opcionDescarga"), 10) || 0;
    this.opcionMenu =
      parseInt(window.sessionStorage.getItem("opcionMenu"), 10) || 0;
    this.getDataPaginaTodos(this.paginaActual);
    this.fetchTipoIdens();
    this.fetchLocalidads();
    this.fetchEstadoCivils();
    this.fetchPerfils();
    this.fetchEspecialidads();
    this.suscripcion();
  },
  methods: {
    handleAction(event, idPersona, nombre) {
      const action = event.target.value;
      if (action === "editar") {
        this.abrirModalEditar(idPersona);
      } else if (action === "detalles") {
        this.abrirEditar(idPersona);
      } else if (action === "borrar") {
        this.deletePersona(idPersona);
      } else if (action === "crearCita") {
        this.crearCita(idPersona);
      } else if (action === "crearNotificacion") {
        this.crearNotificacion(idPersona, nombre);
      }
      event.target.value = "Seleccione...";
    },
    handleRowClick(event, idPersona) {
      if (
        event.target.tagName === "SELECT" ||
        event.target.tagName === "OPTION"
      ) {
        return;
      }
      this.abrirEditar(idPersona);
    },
    mostrarOcultarBloque() {
      this.mostrarBloque = !this.mostrarBloque;
    },
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas() {
      return Math.ceil(this.personas.length / this.elementosPorPagina);
    },
    clearFields(field) {
      if (field !== "cedula") this.cedulaBusqueda = "";
      if (field !== "nombre") this.nombreBusqueda = "";
    },
    buscar() {
      if (this.cedulaBusqueda) {
        this.getDataPagina(1, "cedula");
      } else if (this.nombreBusqueda) {
        this.getDataPagina(1, "nombre");
      } else {
        this.getDataPaginaTodos(1);
      }
    },
    getDataPagina(noPagina, tipoBusqueda) {
      let url;
      if (tipoBusqueda === "cedula" && this.cedulaBusqueda) {
        url = `${config.apiBaseUrl}/vwpersonas/documento?documento=${
          this.cedulaBusqueda
        }&idempresa=${window.sessionStorage.getItem("idEmpresa")}`;
      } else if (tipoBusqueda === "nombre" && this.nombreBusqueda) {
        url = `${config.apiBaseUrl}/vwpersonas/nombrecompleto?nombrecompleto=${
          this.nombreBusqueda
        }&idempresa=${window.sessionStorage.getItem("idEmpresa")}`;
      } else {
        this.getDataPaginaTodos(noPagina);
        return;
      }

      api
        .get(url)
        .then((response) => {
          this.personas = response.data.reverse();
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini =
            noPagina * this.elementosPorPagina - this.elementosPorPagina;
          let fin = noPagina * this.elementosPorPagina;
          this.datosPaginados = this.personas.slice(ini, fin);
        })
        .catch((error) => {
          console.error("Error en la búsqueda:", error);
          swal(
            "Error",
            "No se encontraron datos con los criterios proporcionados.",
            "error"
          );
        });
    },
    getDataPaginaTodos(noPagina) {
      this.cedulaBusqueda = "";
      this.nombreBusqueda = "";
      api.get("/vwpersonas/idempresa/" +
            this.p_idEmpresa
        )
        .then((response) => {
          this.personas = response.data.reverse();
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini =
            noPagina * this.elementosPorPagina - this.elementosPorPagina;
          let fin = noPagina * this.elementosPorPagina;
          this.datosPaginados = this.personas.slice(ini, fin);
        });
    },
    getPreviousPage() {
      if (this.paginaActual > 1) {
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) {
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina) {
      return noPagina == this.paginaActual ? "active" : "";
    },
    validarFormPersona() {
      const requiredFields = [
        "idTipoIden",
        "idLocalidad",
        "idEstadoCivil",
        "documento",
        "primerNombre",
        "segundoNombre",
        "primerApellido",
        "segundoApellido",
        "fechaNac",
        "direccion",
        "telefono",
        "sexo",
        "email",
      ];
      const requiredFieldsText = [
        "idTipoIden",
        "idLocalidad",
        "idEstadoCivil",
        "documento",
        "primerNombre",
        "segundoNombre",
        "primerApellido",
        "segundoApellido",
        "fechaNac",
        "direccion",
        "telefono",
        "sexo",
        "email",
      ];
      return validarForm(this.datoPersona, requiredFields, requiredFieldsText);
    },
    async siguientePaso1() {
      if (this.validarFormPersona() === 1) {
        try {
          this.datoPersona.idEmpresa = this.p_idEmpresa;
          this.datoPersona.tipoPersona = "N";
          const response = await api.post("/personas",
            this.datoPersona
          );
          this.responsePersona = response.data;
          $("#ventanaModalPaso1").modal("hide");
          $("#ventanaModalPaso2").modal("show");
          //          swal("Correcto!", "Persona creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    anteriorPaso2() {
      $("#ventanaModalPaso2").modal("hide");
      $("#ventanaModalPaso1").modal("show");
    },
    validarFormUsuario() {
      const requiredFields = ["idPerfil", "nombre", "clave"];
      const requiredFieldsText = ["idPerfil", "nombre", "clave"];
      return validarForm(this.datoUsuario, requiredFields, requiredFieldsText);
    },
    async siguientePaso2() {
      if (this.validarFormUsuario() === 1) {
        try {
          this.datoUsuario.idUsuarioReg =
            window.sessionStorage.getItem("idUsuario");
          this.datoUsuario.idEmpresa = this.p_idEmpresa;
          this.datoUsuario.idPersona = this.responsePersona.idPersona;
          alert("CONTROL 1: " + this.datoUsuario.idPersona);
          this.datoUsuario.idSuscripcion = this.idSuscripcion;
          await api.post("/usuarios",
            this.datoUsuario
          );
          $("#ventanaModalPaso2").modal("hide");
          $("#ventanaModalPaso3").modal("show");
          //          swal("Correcto!", "Usuario creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    anteriorPaso3() {
      $("#ventanaModalPaso3").modal("hide");
      $("#ventanaModalPaso2").modal("show");
    },
    validarFormMedico() {
      const requiredFields = ["idEspecialidad", "documento"];
      const requiredFieldsText = ["idEspecialidad", "documento"];
      return validarForm(this.datoMedico, requiredFields, requiredFieldsText);
    },
    async finalizarWizard() {
      if (this.registrarComoMedico) {
        if (this.validarFormMedico() === 1) {
          try {
            this.datoMedico.idPersona = this.responsePersona.idPersona;
            await api.post(
              `${config.apiBaseUrl}/medicos?idEmpresa=${this.p_idEmpresa}&idSuscripcion=${this.idSuscripcion}`,
              this.datoMedico
            );
            $("#ventanaModalPaso3").modal("hide");
            swal("Correcto!", "Registro completado exitosamente!", "success");
            this.getDataPagina(this.paginaActual);
          } catch (error) {
            swal("Error!", "Intentelo de nuevo!", "error");
          }
        }
        console.log("Registrado como médico");
      } else {
        console.log("Finalizado sin registrar como médico");
      }
    },
    abrirModalCrear() {
      this.modalWindow = true;
      this.datoPersona = {};
      this.datoUsuario = {};
      this.datoMedico = { esMedico: "false" };
      this.titulo = "Crear Personas";
      this.btnCrear = true;
      this.btnEditar = false;
    },
    abrirModalEditar(idPersona) {
      this.modalWindow = true;
      if (idPersona != null) {
        api.get("/vwpersonas/" + idPersona)
          .then((resp) => {
            this.datoPersona = resp.data;
          });
      }
      $("#ventanaModalPaso1").modal("show");
      this.titulo = "Editar Personas";
      this.btnCrear = false;
      this.btnEditar = true;
    },
    abrirEditar(idPersona) {
      if (idPersona != null) {
        this.$router.push("/personaform/" + idPersona);
      }
    },
    crearCita(idPersona) {
      if (idPersona != null) {
        this.$router.push("/pacientecita02/" + idPersona + "/0/0");
      }
    },
    crearNotificacion(idPersona, nombre) {
      if (idPersona != null) {
        this.$router.push("/bitacoraform/" + idPersona + "/" + nombre);
      }
    },
    async deletePersona(idPersona) {
      try {
        await api.delete("/personas/" + idPersona
        );
        this.getDataPagina(this.paginaActual);
      } catch (error) {
        alert("No se pudo eliminar");
      }
    },
    fetchTipoIdens() {
      fetch(config.apiBaseUrl + "/vwtipoidens")
        .then((response) => response.json())
        .then((data) => {
          this.tipoIdens = data;
        })
        .catch((error) => {
          console.error("Error fetching tipoIdens:", error);
        });
    },
    fetchLocalidads() {
      fetch(config.apiBaseUrl + "/vwlocalidads")
        .then((response) => response.json())
        .then((data) => {
          this.localidads = data;
        })
        .catch((error) => {
          console.error("Error fetching localidads:", error);
        });
    },
    fetchEstadoCivils() {
      fetch(config.apiBaseUrl + "/vwestadocivils")
        .then((response) => response.json())
        .then((data) => {
          this.estadoCivils = data;
        })
        .catch((error) => {
          console.error("Error fetching estadoCivils:", error);
        });
    },
    fetchPerfils() {
      fetch(config.apiBaseUrl + "/vwperfils")
        .then((response) => response.json())
        .then((data) => {
          this.perfils = data;
        })
        .catch((error) => {
          console.error("Error fetching perfils:", error);
        });
    },
    fetchEspecialidads() {
      fetch(config.apiBaseUrl + "/vwespecialidads")
        .then((response) => response.json())
        .then((data) => {
          this.especialidads = data;
        })
        .catch((error) => {
          console.error("Error fetching especialidads:", error);
        });
    },
    openHelp() {
      this.popupAyuda = true;
      this.$refs.helpPopup.open();
    },
    handlePopupClosed() {
      this.popupAyuda = false;
    },
    actualizarDatosDesdePerfil() {
      const perfilSeleccionado = this.perfils.find(
        (perfil) => perfil.idPerfil === this.datoUsuario.idPerfil
      );
      if (perfilSeleccionado) {
        this.datoUsuario.moduloAdministracion =
          perfilSeleccionado.moduloAdministracion;
        this.datoUsuario.moduloAtencion = perfilSeleccionado.moduloAtencion;
        this.datoUsuario.moduloAuditoria = perfilSeleccionado.moduloAuditoria;
        this.datoUsuario.moduloFacturacion =
          perfilSeleccionado.moduloFacturacion;
        this.datoUsuario.moduloDashboards = perfilSeleccionado.moduloDashboards;
        this.datoUsuario.menuParametros = perfilSeleccionado.menuParametros;
        this.datoUsuario.menuProcesos = perfilSeleccionado.menuProcesos;
        this.datoUsuario.menuReportes = perfilSeleccionado.menuReportes;
        this.datoUsuario.menuAyuda = perfilSeleccionado.menuAyuda;
        this.datoUsuario.opcionConsulta = perfilSeleccionado.opcionConsulta;
        this.datoUsuario.opcionOperaciones =
          perfilSeleccionado.opcionOperaciones;
        this.datoUsuario.opcionDescarga = perfilSeleccionado.opcionDescarga;
        this.datoUsuario.opcionMenu = perfilSeleccionado.opcionMenu;
      }
    },
    async suscripcion() {
      try {
        const response = await api.delete(`/vwsuscripcions/idempresa-estadosusc/${this.p_idEmpresa}/VIGENTE`
        );
        // La respuesta es un ArrayList, tomamos el primer item
        const suscripcion = response.data[0];
        // Asignamos el idSuscripcion
        this.idSuscripcion = suscripcion.idSuscripcion;
      } catch (error) {
        console.error("Error al obtener la suscripción:", error);
      }
    },
  },
};
</script>
<style src="@/assets/css/tablaHover.css" scoped></style>
